var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.5C6.22266 13.5 6.75 14.0273 6.75 14.625V16.3125L10.1953 13.7461C10.3711 13.6055 10.6172 13.5 10.8633 13.5H15.75C16.3477 13.5 16.875 13.0078 16.875 12.375V2.25C16.875 1.65234 16.3477 1.125 15.75 1.125H2.25C1.61719 1.125 1.125 1.65234 1.125 2.25V12.375C1.125 13.0078 1.61719 13.5 2.25 13.5H5.625ZM0 2.25C0 1.01953 0.984375 0 2.25 0H15.75C16.9805 0 18 1.01953 18 2.25V12.375C18 13.6406 16.9805 14.625 15.75 14.625H10.8633L6.50391 17.8945C6.32812 18.0352 6.11719 18.0352 5.90625 17.9648C5.73047 17.8594 5.625 17.6836 5.625 17.4375V15.75V14.625H4.5H2.25C0.984375 14.625 0 13.6406 0 12.375V2.25Z",
    fill: "#50638E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8610d842fc5c36cc4ee6197adeb9ac00.svg";
export { ForwardRef as ReactComponent };